import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, forwardRef } from "react";
import Icon from "../../Icon/Icon";
var PinBubbleDefaultMapIcon = /*#__PURE__*/forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.796 12.738L12 20.274l-4.796-7.537C4.795 8.953 7.514 4 12 4c4.486 0 7.205 4.953 4.796 8.738zM5.516 13.81C2.26 8.695 5.936 2 12 2s9.74 6.695 6.484 11.811l-4.797 7.538a2 2 0 01-3.374 0L5.516 13.81zM12 12a2 2 0 100-4 2 2 0 000 4z",
    fill: "currentColor"
  }));
});
export default /*#__PURE__*/memo(PinBubbleDefaultMapIcon);